export const SMART_SESSIONS_ADDRESS = '0x00000000002B0eCfbD0496EE71e01257dA0E37DE';
export const SMART_SESSIONS_COMPATIBILITY_FALLBACK_ADDRESS = '0xBad7E91C4F2803978cd6c7C3Fe80B5Fd7f7B0b50';
//# sourceMappingURL=constants.js.map